import { GridColumnHeaders } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import RulesAddinData from "../models/RulesAddinData";

import { I18nGrid } from "@/components/data/I18nGrid";
import { NameCell } from "@/components/grid/cells/NameCell";
import AddInIds from "@/constants/AddInIds";
import { useUpdateAddIn } from "@/hooks/addins/useUpdateAddIn";

interface Props {
  data?: RulesAddinData[];
  isLoading: boolean;
}

export function PMRulesGrid({ data, isLoading }: Props) {
  const { t } = useTranslation();
  const updateAddIn = useUpdateAddIn<RulesAddinData>(AddInIds.pmrulesData, "ruleId");

  return (
    <>
      <I18nGrid
        rows={data ?? []}
        getRowId={row => row.ruleId}
        slots={{
          columnHeaders: GridColumnHeaders,
        }}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
        }}
        columns={[
          {
            flex: 1,
            minWidth: 200,

            field: "name",
            headerName: t("diagnosticEdit.name", "Name"),
            renderCell: NameCell,
          },
          {
            flex: 1,
            minWidth: 200,

            field: "pmTitle",
            headerName: t("diagnosticEdit.pmTitle", "PM Title"),
            renderCell: NameCell,
            editable: true,
          },
          {
            flex: 1,
            minWidth: 200,
            field: "pmDescription",
            headerName: t("diagnosticEdit.pmDescription", "PM Description"),
            renderCell: NameCell,
            editable: true,
          },
        ]}
        processRowUpdate={async (updatedRow, _) => {
          updateAddIn.mutate({
            ruleId: updatedRow.ruleId,
            pmTitle: updatedRow.pmTitle,
            pmDescription: updatedRow.pmDescription,
          });

          return updatedRow;
        }}
        onProcessRowUpdateError={error => console.error(error)}
        loading={isLoading}
      />
    </>
  );
}
